
import Container from '../components/Container';
import FullWidthLayout from '../layouts/FullWidthLayout';
import Button from '@mui/joy/Button';
import Stack from '@mui/joy/Stack';
import Typography from '@mui/joy/Typography';
import * as Api from '../services/api';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowUpRightFromSquare, faSpinner, faXmark } from '@fortawesome/free-solid-svg-icons';
import { Box, FormControl, FormHelperText, FormLabel, IconButton, Input, Modal, ModalDialog, Option, Select, Sheet, Table, Tooltip } from '@mui/joy';
import ButtonGroup from '@mui/joy/ButtonGroup';
import { useEffect, useMemo, useState } from 'react';
import moment from 'moment';
import Notification from '../services/notification';
import PhoneInput, { formatPhoneNumberIntl, isPossiblePhoneNumber } from 'react-phone-number-input';
import 'react-phone-number-input/style.css';
import '../components/CopyCatInput.css';
import { validateEmail } from '../utils/emailValidator';

const { origin } = window.location;

const ADMIN = {
	clear: {
		ownerName: '',
		ownerPhone: '',
		ownerEmail: ''
	},
	aaron: {
		ownerName: 'Aaron Sloup',
		ownerPhone: '+1 913 530 1746',
		ownerEmail: 'aaron@andme.org'
	},
	dan: {
		ownerName: 'Dan Carroll',
		ownerPhone: '+1 650 861 2211',
		ownerEmail: 'dan@andme.org',
	},
	kevin: {
		ownerName: 'Kevin Manase',
		ownerPhone: '+1 785 236 9539',
		ownerEmail: 'kevin@andme.org'
	}
};

const BrandsManagerPage = () => {
	const [pricingStrategy, setPricingStrategy] = useState('instant_sell_price');
	const [commaSeparatedTags, setCommaSeparatedTags] = useState('');
	const [ownerName, setOwnerName] = useState('');
	const [ownerPhone, setOwnerPhone] = useState('');
	const [ownerEmail, setOwnerEmail] = useState('');
	const [canSubmit, setCanSubmit] = useState(false);
	const [didSubmit, setDidSubmit] = useState(false);
	const [didDeleteRow, setDidDeleteRow] = useState(false);
	const [showConfirmDelete, setShowConfirmDelete] = useState(false);
	const [tagToDelete, setTagToDelete] = useState('');
	const [isDataStale, setIsDataStale] = useState(false);
	const [price, setPrice] = useState('');
	const [heldTags, setHeldTags] = useState([]);

	useEffect(() => {
		Api.getHeldBrandTags()
			.then((res) => {
				setHeldTags(res);
				setIsDataStale(false);
			})
			.catch((err) => {
				console.error(err);
			});
	}, [isDataStale]);

	useEffect(() => {
		if (commaSeparatedTags.length > 0 && ownerName.length > 0 && isPossiblePhoneNumber(ownerPhone || '') && validateEmail(ownerEmail || '')) {
			setCanSubmit(true);
		} else {
			setCanSubmit(false);
		}
	}, [commaSeparatedTags, ownerName, ownerPhone, ownerEmail]);

	function askDeleteConfirmation(tag, index) {
		setShowConfirmDelete(true);
		setTagToDelete(tag);
	}

	async function handleDelete(e) {
		e.preventDefault();

		setDidDeleteRow(true);
		await Api.deleteTag(tagToDelete.tag || tagToDelete.text);
		setIsDataStale(true);
		setDidDeleteRow(false);
		setShowConfirmDelete(false);
		setTagToDelete('');
	}

	// const handleSelectAllClick = (event) => {
	// 	// TODO: if we wanted to select all. but this doesn't really work with the way that the access codes work.
	// 	// if (event.target.checked) {
	// 	// 	setSelected(heldTags);
	// 	// 	return;
	// 	// }
	// 	setSelected([]);
	// 	setSelectedTags([]);
	// };

	// function handleRowClick(event, tag) {
	// 	event.preventDefault();
	// 	// return index of the tag in the selected array of object
	// 	const selectedIndex = selected.map((selectedTag) => selectedTag.tag).indexOf(tag.tag);
	// 	let newSelected = [];

	// 	if (selected.length && tag.holdOverrideCode !== selected[0].holdOverrideCode) {
	// 		if (!Notification.isActive()) {
	// 			Notification.warning('You can only bundle tags that have the same access code.');
	// 		}
	// 		return;
	// 	}

	// 	if (selectedIndex === -1) {
	// 		newSelected = newSelected.concat(selected, tag);
	// 	} else if (selectedIndex === 0) {
	// 		newSelected = newSelected.concat(selected.slice(1));
	// 	} else if (selectedIndex === selected.length - 1) {
	// 		newSelected = newSelected.concat(selected.slice(0, -1));
	// 	} else if (selectedIndex > 0) {
	// 		newSelected = newSelected.concat(
	// 			selected.slice(0, selectedIndex),
	// 			selected.slice(selectedIndex + 1),
	// 		);
	// 	}

	// 	setSelected(newSelected);
	// 	setSelectedTags(newSelected.map(tag => tag.tag));
	// }

	function getBundledTags(tag) {
		return heldTags.filter(t => t.holdOverrideCode === tag.holdOverrideCode);
	}

	function getTooltipTitle(tag) {
		const tags = heldTags.filter(t => t.holdOverrideCode === tag.holdOverrideCode && t.tag !== tag.tag);

		const tagsString = tags.map(t => t.tag).join(', ');

		if (tags.length === 0) {
			return '';
		}

		return `This tag is bundled with ${tagsString}`;
	}

	function quickFill(name) {
		setOwnerName(ADMIN[name].ownerName);
		setOwnerPhone(ADMIN[name].ownerPhone);
		setOwnerEmail(ADMIN[name].ownerEmail);
	}

	function getLink({ tag, holdOverrideCode }) {
		if (!tag) {
			return '#';
		}

		const bundledTags = getBundledTags({ tag, holdOverrideCode });

		if (bundledTags.length > 1) {
			return `${origin}/brands/claim/?tags=${bundledTags.map(t => t.tag).join('%2C')}&accessCode=${holdOverrideCode}`;
		}

		return `${origin}/brands/claim/?tags=${tag}&accessCode=${holdOverrideCode}`;
	}

	const tableRows = useMemo(() => {
		return heldTags.map((tag, index) => {
			// const isItemSelected = selectedTags.includes(tag.tag);
			const labelId = `enhanced-table-checkbox-${index}`;
			return (
				<tr
					// role="checkbox"
					// // aria-checked={isItemSelected}
					// tabIndex={-1}
					// style={
					// 	isItemSelected
					// 		? {
					// 			'--TableCell-dataBackground':
					// 				'var(--and-palette-primary-200, #50BFB4)',
					// 			'--TableCell-headBackground':
					// 				'var(--TableCell-selectedBackground)',
					// 		}
					// 		: {}
					// }
					key={tag.tag}
				>
					{/* <th scope="row">
						<Checkbox
							checked={isItemSelected}
							onClick={(event) => handleRowClick(event, tag)}
							slotProps={{
								input: {
									'aria-labelledby': labelId,
								},
							}}
							sx={{ verticalAlign: 'top' }}
						/>
					</th> */}
					<td>
						<Tooltip title={getTooltipTitle(tag)}>
							<a href={getLink(tag)} style={{ textDecorationLine: 'underline' }} target="_blank" rel="noreferrer" >{tag.tag}&nbsp;<FontAwesomeIcon icon={faArrowUpRightFromSquare} />
							</a>
						</Tooltip>
					</td>
					<td>{tag.ownerName}</td>
					<td>{tag.ownerEmail}</td>
					<td>{formatPhoneNumberIntl(tag.ownerPhone)}</td>
					<td>{tag.instantSellPrice ? `$${tag.instantSellPrice}` : '-'}</td>
					<td>{tag.instantSellAtFMV ? 'Yes' : 'No'}</td>
					<td>{moment(tag.holdExpiresTime).fromNow()}</td>
					<td>{tag.holdOverrideCode}</td>
					<td>{tag.discountId ? 'Yes' : 'No'}</td>
					<td>
						<Button size="sm" variant="soft" disabled={didDeleteRow} color="danger" onClick={() => askDeleteConfirmation(tag)}>
							Delete
						</Button>
					</td>
				</tr >
			);
		});
	}, [heldTags, didDeleteRow]);

	function handlePricingStrategyChange(e, value) {
		setPricingStrategy(value);
	}

	async function submitForm(e) {
		e.preventDefault();
		setDidSubmit(true);
		const decodedTags = decodeURIComponent(commaSeparatedTags);
		// remove all ampersands from the string
		const cleanCST = decodedTags.replace(/&/g, '');
		const tags = cleanCST.split(',');
		// remove duplicate tags
		const uniqueTags = [...new Set(tags)];
		const payload = {
			tags: uniqueTags,
			ownerName,
			ownerPhone,
			ownerEmail,
			...(pricingStrategy === 'instant_sell_price' && { price }),
			pricingStrategy,
		};

		await Api.holdBrandTags(payload)
			.then(() => {
				Notification.success('Successfully held tag(s).');
				setIsDataStale(true);
				setDidSubmit(false);
				setCommaSeparatedTags('');
				setOwnerName('');
				setOwnerPhone('');
				setOwnerEmail('');
				// leave as is
				// setPricingStrategy('instant_sell_price');
				setPrice('');
			})
			.catch((err) => {
				Notification.error('Something went wrong.');
				console.error(err);
				setDidSubmit(false);
			}
			);
	}

	const handleOnChange = (event) => {
		const regex = /^[a-zA-Z0-9,]*$/; // allows only alphanumeric characters

		// if comma is the last char, return
		// no 2 commas should be next to each other
		if (event.nativeEvent.data === ',' && commaSeparatedTags.endsWith(',')) {
			event.preventDefault();
			return;
		}

		// test each character entered
		if (!regex.test(event.nativeEvent.data)) {
			event.preventDefault();
			return;
		}
		setCommaSeparatedTags(event.target.value.toLowerCase());
	};

	return (
		<FullWidthLayout>
			<Container>
				<Typography level="h1">🛠️ Brand Manager</Typography>
				<Stack spacing={3}>
					<Sheet>
						<Typography level="h2">Hold &tag(s)</Typography>
						<Typography level="body2">Fill out the form below to hold brand &tag(s).</Typography>
					</Sheet>
					<Sheet>
						<form onSubmit={submitForm}>
							<Stack spacing={2}>
								<FormControl>
									<FormLabel required>&tag(s)</FormLabel>
									<Input
										autoComplete="off"
										autoFocus
										required
										value={commaSeparatedTags}
										onChange={handleOnChange} />
									<FormHelperText>You can hold multiple &tags by separating them with a comma.</FormHelperText>
								</FormControl>
								<FormControl>
									<FormLabel required>Pricing strategy</FormLabel>
									<Select defaultValue='instant_sell_price' onChange={handlePricingStrategyChange}>
										<Option value="instant_sell_price">Instant Sell Price</Option>
										<Option value="fmv">Fair Market Value</Option>
										<Option value="free">Free</Option>
										<Option value="custom_discount" disabled>Custom Discount</Option>
									</Select>
								</FormControl>
								{pricingStrategy === 'instant_sell_price' &&
									< FormControl >
										<FormLabel required>Instant Sell Price</FormLabel>
										<Input
											autoFocus
											required
											type="number"
											value={price}
											startDecorator={{ dollar: '$' }['dollar']}
											onChange={(e) => {
												const value = e.target.value;
												const rounded = Math.round(value);
												setPrice(rounded.toString());
											}} />
									</FormControl>
								}
								<Sheet>
									<Typography level="body2">
										Quick-fill
									</Typography>
									<ButtonGroup
										color="primary"
										orientation="horizontal"
										size="sm"
										variant="outlined"
									>
										<Button onClick={() => quickFill('aaron')} sx={{ borderRadius: '10px 0 0 10px' }}>Aaron</Button>
										<Button onClick={() => quickFill('dan')} sx={{ borderRadius: '10px 0 0 10px' }}>Dan</Button>
										<Button onClick={() => quickFill('kevin')} sx={{ borderRadius: '0px 10px 10px 0px' }}>Kevin</Button>
										<IconButton onClick={() => quickFill('clear')} sx={{ borderRadius: '0px 10px 10px 0px' }}>
											<FontAwesomeIcon icon={faXmark} />
										</IconButton>
									</ButtonGroup>
								</Sheet>
								<FormControl>
									<FormLabel required>Manager Full Name</FormLabel>
									<Input autoFocus required value={ownerName} onChange={(e) => setOwnerName(e.target.value)} />
								</FormControl>
								<FormControl>
									<FormLabel required>Manager Phone Number</FormLabel>
									<PhoneInput
										className="MuiInput-root MuiInput-variantOutlined MuiInput-colorNeutral MuiInput-sizeMd MuiInput-formControl CopyCat-input"
										limitMaxLength={true}
										autoComplete="tel"
										useNationalFormatForDefaultCountryValue={true}
										defaultCountry="US"
										value={ownerPhone}
										onChange={setOwnerPhone} />
								</FormControl>
								<FormControl>
									<FormLabel required>Manager Email Address</FormLabel>
									<Input type="email" required value={ownerEmail} onChange={(e) => setOwnerEmail(e.target.value)} />
								</FormControl>
								{!didSubmit ? <Button disabled={!canSubmit} type="submit">Submit</Button>
									:
									<Button disabled={didSubmit} type="submit"><FontAwesomeIcon icon={faSpinner} spinPulse /></Button>
								}
							</Stack>
						</form>
					</Sheet>
					<Sheet>
						<Typography level="h2">Held &tags</Typography>
						<Typography level="body2">Here is a list of brand &tags that are  held by for The & Company.</Typography>
					</Sheet>
					<Box sx={{ width: '100%' }}>
						<Sheet
							sx={{
								'--TableCell-height': '40px',
								// the number is the amount of the header rows.
								'--TableHeader-height': 'calc(1 * var(--TableCell-height))',
								'--Table-firstColumnWidth': '150px',
								'--Table-lastColumnWidth': '80px',
								// background needs to have transparency to show the scrolling shadows
								'--TableRow-stripeBackground': 'rgba(0 0 0 / 0.04)',
								'--TableRow-hoverBackground': 'rgba(0 0 0 / 0.08)',
								overflow: 'auto',
								background: (theme) =>
									`linear-gradient(to right, ${theme.vars.palette.background.surface} 30%, rgba(255, 255, 255, 0)),
								linear-gradient(to right, rgba(255, 255, 255, 0), ${theme.vars.palette.background.surface} 70%) 0 100%,
								radial-gradient(
									farthest-side at 0 50%,
									rgba(0, 0, 0, 0.12),
									rgba(0, 0, 0, 0)
								),
								radial-gradient(
										farthest-side at 100% 50%,
										rgba(0, 0, 0, 0.12),
										rgba(0, 0, 0, 0)
									)
									0 100%`,
								backgroundSize:
									'40px calc(100% - var(--TableCell-height)), 40px calc(100% - var(--TableCell-height)), 14px calc(100% - var(--TableCell-height)), 14px calc(100% - var(--TableCell-height))',
								backgroundRepeat: 'no-repeat',
								backgroundAttachment: 'local, local, scroll, scroll',
								backgroundPosition:
									'var(--Table-firstColumnWidth) var(--TableCell-height), calc(100% - var(--Table-lastColumnWidth)) var(--TableCell-height), var(--Table-firstColumnWidth) var(--TableCell-height), calc(100% - var(--Table-lastColumnWidth)) var(--TableCell-height)',
								backgroundColor: 'background.surface',
							}}
						>
							<Table
								borderAxis="bothBetween"
								hoverRow
								color="neutral"
								size="md"
								variant="outlined"
								aria-label="basic table"
								sx={{
									'& tr > *:first-of-type': {
										position: 'sticky',
										left: 0,
										boxShadow: '1px 0 var(--TableCell-borderColor)',
										bgcolor: 'background.surface',
									},
									'& tr > *:last-child': {
										position: 'sticky',
										right: 0,
										bgcolor: 'background.surface',
									},
								}}
							>
								<thead>
									<tr>
										{/* <th>
											{!!selected.length && (
												<Checkbox
													indeterminate={selected.length > 0 && selected.length < heldTags.length}
													checked={heldTags.length > 0 && selected.length === heldTags.length}
													onChange={handleSelectAllClick}
													slotProps={{
														input: {
															'aria-label': 'select all tags',
														},
													}}
													sx={{ verticalAlign: 'sub' }}
												/>
											)}
										</th> */}
										<th style={{ width: 'var(--Table-firstColumnWidth)' }}>&tag</th>
										<th style={{ width: 150 }}>
											Owner Name
										</th>
										<th style={{ width: 200 }}>
											Owner Email</th>
										<th style={{ width: 150 }}>
											Owner Phone</th>
										<th style={{ width: 80 }}>
											Instant Sell Price</th>
										<th style={{ width: 100 }}>
											Sell @ FMV?</th>
										<th style={{ width: 100 }}>
											Hold Expiry</th>
										<th style={{ width: 200 }}>
											Access Code</th>
										<th style={{ width: 50 }}>
											Free</th>
										<th
											aria-label="last"
											style={{ width: 'var(--Table-lastColumnWidth)' }}
										/>
									</tr>
								</thead>
								<tbody>
									{heldTags.length === 0 && <tr><td colSpan={9}>A bit lonely here...</td></tr>}
									{tableRows}
								</tbody>
							</Table>
						</Sheet>
					</Box>
				</Stack>
			</Container>
			<Modal open={showConfirmDelete} onClose={() => setShowConfirmDelete(true)}>
				<ModalDialog
					aria-labelledby="basic-modal-dialog-title"
					aria-describedby="basic-modal-dialog-description"
					sx={{ maxWidth: 500 }}
				>
					<Typography id="basic-modal-dialog-title" component="h2">
						You're about to delete &{tagToDelete.tag || tagToDelete.text}
					</Typography>
					<Typography id="basic-modal-dialog-description" component="p">
						Are you sure you want to do that?
					</Typography>
					<form
						onSubmit={(event) => {
							event.preventDefault();
							setShowConfirmDelete(false);
						}}
					>
						<Stack spacing={1}>
							<Button type="submit" disabled={didDeleteRow} onClick={handleDelete}>Yes</Button>
							<Button type="button" variant="plain" onClick={() => setShowConfirmDelete(false)}>No</Button>
						</Stack>
					</form>
				</ModalDialog>
			</Modal>
		</FullWidthLayout >
	);
};

export default BrandsManagerPage;
